import React from 'react'

export const NotFoundPage = () => (
  <div className="grid-outer-container">
    <div>Page does not exist.</div>
  </div>
)
